import { ButtonHTMLAttributes } from "react"
import './LinkButton.less'

const LinkButton = (props: ButtonHTMLAttributes<HTMLButtonElement>): JSX.Element => (
  <button {...props} className={`link-button ${props.className}`} />
)

export default LinkButton
